import React from "react";
import { Alert, Input } from "reactstrap";
import NeoLoader from "../../../components/Common/NeoLoader";
import { Breadcrumb } from "../../../components/Common";
import { useDRE } from "./hooks/useDRE";
import DRETable from "./components/DRETable";
import DREInfoCards from "./components/DREInfoCards";
import { MONTH_LABELS, getAvailableYears } from "./constants";

/**
 * DREPage
 * Demonstração do Resultado do Exercício — Relatório gerencial.
 * Layout segue o padrão de Settings: sem page-content, sem Container.
 */
const DREPage = () => {
    document.title = "DRE | NeoApp - Sistema de Gestão";

    const {
        dreData,
        year,
        month,
        setYear,
        setMonth,
        loading,
        error,
        actions,
    } = useDRE();

    const years = getAvailableYears();

    return (
        <React.Fragment>
            {/* ═══ HEADER ═══ */}
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="DRE Gerencial" />
                <div className="d-flex align-items-center gap-2">
                    <Input
                        type="select"
                        value={year}
                        onChange={(e) => setYear(Number(e.target.value))}
                        className="form-select border bg-white rounded-3 py-1 px-3 font-size-13 text-dark fw-bold"
                        style={{ width: "120px", borderColor: "rgba(72, 39, 18, 0.15)", height: "38px", cursor: "pointer", fontFamily: "Outfit, sans-serif" }}
                    >
                        {years.map(y => (
                            <option key={y.value} value={y.value}>{y.label}</option>
                        ))}
                    </Input>
                    <Input
                        type="select"
                        value={month}
                        onChange={(e) => setMonth(Number(e.target.value))}
                        className="form-select border bg-white rounded-3 py-1 px-3 font-size-13 text-dark fw-bold"
                        style={{ width: "160px", borderColor: "rgba(72, 39, 18, 0.15)", height: "38px", cursor: "pointer", fontFamily: "Outfit, sans-serif" }}
                    >
                        {MONTH_LABELS.map((label, i) => (
                            <option key={i + 1} value={i + 1}>{label}</option>
                        ))}
                    </Input>
                </div>
            </div>

            <div className="border-top mb-3"></div>

            {/* ═══ LOADING ═══ */}
            {loading && (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                    <NeoLoader type="inline" loading={loading} />
                </div>
            )}

            {/* ═══ ERROR ═══ */}
            {error && !loading && (
                <Alert color="danger" className="d-flex align-items-center">
                    <i className="mdi mdi-alert-circle-outline me-2 fs-5" />
                    <div>
                        <strong>Erro ao carregar dados:</strong> {error}
                        <button className="btn btn-link btn-sm p-0 ms-2" onClick={actions.refresh}>
                            Tentar novamente
                        </button>
                    </div>
                </Alert>
            )}

            {/* ═══ CONTEÚDO ═══ */}
            {!loading && !error && (
                <>
                    <DRETable dreData={dreData} year={year} month={month} />
                    <DREInfoCards />
                </>
            )}
        </React.Fragment>
    );
};

export default DREPage;
